import React from "react";
import styled from "styled-components";

const MainNavGroup = styled.div`
  margin-top: 0;
  margin-bottom: ${(props) => props.theme.spacing.s2};
`;

export default MainNavGroup;
